import React from 'react';
import { UitkFigure, UitkImage, UitkFigureAspectRatioType } from 'uitk-react-images';
import { CopyRightIMG, CopyRightProps } from '../copyrightimg/copyrightimg';
import { checkValue } from 'src/components/common/helper';

interface FigureProps {
  src: string;
  exClass?: string;
  ratio?: UitkFigureAspectRatioType;
  imageFit?: 'cover' | 'contain';
  alt?: string;
  children?: React.ReactNode;
  blankDefault?: boolean;
  placeholderImage?: boolean;
  isGradientActive?: boolean;
  copyRightProps?: CopyRightProps;
  imageRatio?: any;
}

const Figure: React.FC<FigureProps> = props => {
  const {
    alt,
    children,
    src = '',
    exClass = '',
    imageFit = 'cover',
    blankDefault = true,
    placeholderImage = true,
    isGradientActive = true,
    ...rest
  } = props;

  const imageRatio = checkValue(props?.imageRatio) ? props.imageRatio : ''; 

  return (
    <UitkFigure className={exClass} {...rest} imageFit={imageFit} ratio={imageRatio}>
      {isGradientActive && <div className="gradient"></div>}
      <UitkImage alt={alt} src={src} placeholderImage={placeholderImage} blankDefault={blankDefault} />
      {checkValue(children) ? children : null}
      {rest.copyRightProps  && <CopyRightIMG {...rest.copyRightProps}/>}
    </UitkFigure>
  );
};

export { FigureProps, Figure };
